<template>
  <div>
    <div
      id="updates-container"
      class="updates-container"
      v-if="value && value.length > 0"
    >
      <div class="project-update" v-for="update of value" :key="update.id">
        <div>
          <div class="heading">
            <h6>
              {{
                update.createdBy
                  ? update.createdBy.firstName + ' ' + update.createdBy.lastName
                  : ''
              }}
            </h6>
            <span class="date">{{ formatDate(update.createdAt, '') }}</span>
          </div>
          <p class="desc">{{ update.description }}</p>
        </div>
      </div>
    </div>
    <div v-else>
      <span>This project does not have any updates yet.</span>
    </div>
    <b-overlay :show="loading" rounded="sm">
      <div class="mt-2" v-if="addingUpdate">
        <div class="d-flex align-items-center">
          <b-form-textarea
            v-model="newProjectUpdate"
            size="sm"
            placeholder="Add an update"
          ></b-form-textarea>
          <div class="ml-2">
            <icon-arrow-up
              style="cursor: pointer"
              @click="addUpdate"
              font-scale="1.2"
            />
            <icon-x-circle
              style="cursor: pointer"
              @click="addingUpdate = false"
              font-scale="1.2"
            />
          </div>
        </div>
        <div class="error" v-show="error">{{ error }}</div>
      </div>
      <b-btn
        class="mt-2"
        v-else-if="userIsMember"
        @click="addingUpdate = true"
        variant="outline-dark"
        block
        >Add an update</b-btn
      >
    </b-overlay>
  </div>
</template>

<script>
import moment from 'moment';
import { BIconArrowUpSquare, BIconXCircle } from 'bootstrap-vue';
import api from '../api';
export default {
  components: {
    'icon-arrow-up': BIconArrowUpSquare,
    'icon-x-circle': BIconXCircle,
  },
  props: {
    projectId: Number,
    value: Array,
    userIsMember: { type: Boolean, default: false },
  },
  watch: {
    value() {
      this.scrollToTop();
    },
  },
  data() {
    return {
      addingUpdate: false,
      newProjectUpdate: '',
      loading: false,
      error: '',
    };
  },
  computed: {
    app_user() {
      return this.$store.getters.app_user || {};
    },
  },
  methods: {
    async addUpdate() {
      if (!this.newProjectUpdate) return;
      try {
        this.loading = true;
        const {
          data: {
            data: { createdProjectUpdate },
          },
        } = await api.createProjectUpdate(this.projectId, {
          description: this.newProjectUpdate,
        });

        createdProjectUpdate.createdBy = {
          firstName: this.app_user.firstName,
          lastName: this.app_user.lastName,
        };

        this.$emit('input', [createdProjectUpdate, ...this.value]);

        this.addingUpdate = false;
        this.newProjectUpdate = '';
        this.error = '';
      } catch (e) {
        if (e.response && e.response.status === 400 && e.response.data) {
          this.error = e.response.data.details;
        } else {
          console.error(e);
          this.error = 'Could not create project update';
        }
      } finally {
        this.loading = false;
      }
    },
    formatDate(date, fallback, format) {
      format = format || 'DD MMM YYYY';
      if (!date) {
        return fallback;
      }
      return moment(date).format(format);
    },
    scrollToTop() {
      this.$nextTick(() => {
        var div = document.getElementById('updates-container');
        if (div) div.scrollTop = 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.updates-box {
  // background-color: rgb(238, 238, 238);
  // border-radius: 3px;
  border-color: grey;
}

.updates-container {
  overflow-y: auto;
  max-height: 520px;
}

.project-update {
  // background-color: rgb(238, 238, 238);
  border: 1px solid #e2e5ec !important;
  border-radius: 3px;
  margin: 5px 0 0;
  padding: 4px;
  .heading {
    display: flex;
    justify-content: space-between;

    h6 {
      font-size: 14px;
    }
    .date {
      font-size: 10px;
      color: #acb6c1;
    }
  }

  p {
    margin: 0;
  }
}

.error {
  color: $red;
  text-align: center;
  width: 100%;
  top: calc(50% + 160px);
  font-size: 14px;
}

::-webkit-scrollbar {
  width: 14px;
}

::-webkit-scrollbar-thumb {
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  border-radius: 9999px;
  background-color: #aaaaaa;
}
</style>
